import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoPrestacionModalidadCiclica = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoPrestacionModalidadCiclica = () => {
  const [loadingGetInfoPrestacionModalidadCiclica, setLoadingGetInfoPrestacionModalidadCiclica] = useState(false);
  const [successGetInfoPrestacionModalidadCiclica, setSuccessGetInfoPrestacionModalidadCiclica] = useState(false);
  const [errorGetInfoPrestacionModalidadCiclica, setErrorGetInfoPrestacionModalidadCiclica] = useState<any>(null);
  const [dataGetInfoPrestacionModalidadCiclica, setDataGetInfoPrestacionModalidadCiclica] = useState<any>(null);

  const [statusGetInfoPrestacionModalidadCiclica, setStatusGetInfoPrestacionModalidadCiclica] =
    useState<StatusGetInfoPrestacionModalidadCiclica>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoPrestacionModalidadCiclica = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoPrestacionModalidadCiclica(true);
    setSuccessGetInfoPrestacionModalidadCiclica(false);
    setErrorGetInfoPrestacionModalidadCiclica(null);

    try {
      const res = await apiRecord.getInfoSolicitudModalidadCiclica(userId);

      setStatusGetInfoPrestacionModalidadCiclica({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoPrestacionModalidadCiclica(true);
      setDataGetInfoPrestacionModalidadCiclica(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoPrestacionModalidadCiclica({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoPrestacionModalidadCiclica(err);
      console.error("Error en getInfoPrestacionModalidadCiclica:", err);

      throw err;

    } finally {
      setLoadingGetInfoPrestacionModalidadCiclica(false);
    }
  };

  return {
    getInfoPrestacionModalidadCiclica,
    loadingGetInfoPrestacionModalidadCiclica,
    successGetInfoPrestacionModalidadCiclica,
    errorGetInfoPrestacionModalidadCiclica,
    dataGetInfoPrestacionModalidadCiclica,
    statusGetInfoPrestacionModalidadCiclica
  };
};

export default useGetInfoPrestacionModalidadCiclica;
